/* QUOALA 05.10.2026 (Greg: «gilt überall so – auch auf Home»): Bewertungs-Karussell ausserhalb der Produktseite (Judge.me «jdgm-carousel», z. B. Startseite).
   Desktop: Pfeile blättern um alle sichtbaren Karten statt um eine und laufen rundum (am Ende wieder an den Anfang, am Anfang ans Ende).
   Handy (< 750 px): unverändert, dort wird gewischt. Die Produktseite hat ein anderes Widget – dessen Pfeile stehen in assets/quoala-v5.js. */
(function () {
  function wire() {
    var wrap = document.querySelector('.jdgm-carousel__item-wrapper'), box = document.querySelector('.jdgm-carousel__item-container');
    var R = document.querySelector('.jdgm-carousel__right-arrow'), L = document.querySelector('.jdgm-carousel__left-arrow');
    if (!wrap || !box || !R || !L) return false;
    if (wrap.__q5) return true;
    wrap.__q5 = true;
    function go(d, e) {
      if (window.innerWidth < 750) return;
      var it = wrap.querySelectorAll('.jdgm-carousel-item');
      if (it.length < 2) return;
      e.preventDefault(); e.stopImmediatePropagation();
      var st = it[1].getBoundingClientRect().left - it[0].getBoundingClientRect().left;
      var per = Math.max(1, Math.round(box.clientWidth / st)), max = Math.max(0, it.length - per);
      var m = /translate3d\((-?[\d.]+)px/.exec(wrap.style.transform || ''), idx = m ? Math.round(-parseFloat(m[1]) / st) : 0, nx;
      if (d > 0) nx = idx >= max ? 0 : Math.min(max, idx + per); else nx = idx <= 0 ? max : Math.max(0, idx - per);
      wrap.style.transform = 'translate3d(' + (-nx * st) + 'px, 0px, 0px)';
      R.style.opacity = '1'; L.style.opacity = '1';
    }
    R.addEventListener('click', function (e) { go(1, e); }, true);
    L.addEventListener('click', function (e) { go(-1, e); }, true);
    return true;
  }
  if (wire()) return;
  var n = 0, t = setInterval(function () { if (wire() || ++n > 60) clearInterval(t); }, 500);
})();
